import moment from 'moment';

import { time } from 'utils';

function isEmptyDate(value: nil | string): boolean {
  return !time.isValid(value as moment.MomentInput, 'datetimems');
}

export { isEmptyDate };
